import React from 'react';

import autoBind from 'react-autobind';

import { CircularProgress } from '@material-ui/core'

// import other components within the same project here

const styles = {
  loadingOverlay: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    zIndex: '99999',
    backgroundColor: 'rgba(255,255,255,0.2)',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
  },
  loadingContent: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
  }
}

class Loading extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
    };
    autoBind(this);
  }

  render() {
    if (this.props.isLoading) {
      return (
        <div style={styles.loadingOverlay}>
          <CircularProgress styles={styles.loadingContent}/>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default Loading;
